import { useState, useLayoutEffect } from 'react';

import { teachersStore } from './teachers-store';

export const useTeachersState = () => {
  const [state, setState] = useState(teachersStore.initialState);

  useLayoutEffect(() => {
    const subscription = teachersStore.subscribe(setState);
    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return {
    teachersState: state,
  };
};
